import { Translation, Locale } from '../entities';
import { IInternationalizationRepository } from '../entities/IInternationalizationRepository';

export interface IInternationalizationService {
  GetAvailableLanguages(data: { channelRelativePath: string }): Promise<Locale[]>;
  GetTranslations(data: { channelRelativePath: string; locale: string }): Promise<Translation[]>;
  PersistLanguage(data: { language: string }): Promise<any>;
}

export class InternationalizationServiceImpl implements IInternationalizationService {
  itemRepo: IInternationalizationRepository;

  constructor(ir: IInternationalizationRepository) {
    this.itemRepo = ir;

    this.GetAvailableLanguages = this.GetAvailableLanguages.bind(this);
    this.GetTranslations = this.GetTranslations.bind(this);
    this.PersistLanguage = this.PersistLanguage.bind(this);
  }

  GetAvailableLanguages(data: { channelRelativePath: string }): Promise<Locale[]> {
    return this.itemRepo.GetAvailableLanguages(data.channelRelativePath);
  }

  GetTranslations(data: { channelRelativePath: string; locale: string }): Promise<Translation[]> {
    return this.itemRepo.GetTranslations(data);
  }

  PersistLanguage(data: { language: string }): Promise<any> {
    return this.itemRepo.PersistLanguage(data);
  }
}
